import React, { useEffect } from 'react';
import ToastBanner, { Alert } from '../components/Molecules/ToastBanner/ToastBanner';
import useStore from '../store/useStore';

const ToastBannerContainer = () => {
  const { toastBanner, setAttemptTracker, setAnalyticsProducts } = useStore();

  useEffect(() => {
    if (toastBanner) {
      Alert({ message: toastBanner.message, type: toastBanner.type });
      setTimeout(() => {
        setAnalyticsProducts({
          bannerMessage: toastBanner.message,
          bannerMessageEvent: 1,
          componentTitle: 'header',
          clickActionName: 'banner impression',
          giftCardTransferBalance: toastBanner.giftCardTransferBalance,
        });
        setAttemptTracker([{ name: 'banner_notification_impression' }]);
      }, 4000);
    }
  }, [toastBanner]);

  return <ToastBanner styleAlert="success" />;
};

export default ToastBannerContainer;
